gsap.registerPlugin(ScrollTrigger);

window.onload = () => {
    ScrollTrigger.refresh();
};

let media_sm = gsap.matchMedia();
media_sm.add("(max-width: 767px)", () => { 
    const contentNumbers = document.querySelectorAll('.content-number');
    if(contentNumbers.length > 0){
        contentNumbers.forEach(number => {
            number.classList.add('content-number-bg');
        });
    }
    
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".multi-image-with-text-main",
            start: "top 5%",
            end: "bottom 10%",
            scrub: 1,
            pin: true
        }
    });

    tl.addLabel("secondContent")
        .to(".multi-image-parent-img.image-1", { opacity: 0, zIndex: 1 }, "secondContent")
        .to(".content-item-1", { opacity: 0, zIndex: 1 }, "secondContent")
        .to(".multi-image-parent-img.image-2", { opacity: 1, zIndex: 10 }, "secondContent")
        .fromTo(".content-item-2", { opacity: 0, zIndex: 1, y: "100%" }, { opacity: 1, zIndex: 10, y: 0 }, "secondContent")
        .addLabel("thirdContent")
        .to(".multi-image-parent-img.image-2", { opacity: 0, zIndex: 1 }, "thirdContent")
        .to(".content-item-2", { opacity: 0, zIndex: 1 }, "thirdContent")
        .to(".multi-image-parent-img.image-3", { opacity: 1, zIndex: 10 }, "thirdContent")
        .fromTo(".content-item-3", { opacity: 0, zIndex: 1, y: "100%" }, { opacity: 1, zIndex: 10, y: 0 }, "thirdContent");
});


// Media query for screens between 768px and onwards
let media_md = gsap.matchMedia();
media_md.add("(min-width: 768px)", () => { 
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".multi-image-with-text-main",
            start: "top 10%",
            end: "bottom 15%",
            scrub: 1,
            pin: true,
            markers: false,
            onUpdate: (self) => {
                const progress = self.progress;
                const contentNumbers = document.querySelectorAll('.content-number');
                
                if(contentNumbers.length > 0){
                    const removeActiveClasses = () => {
                        contentNumbers.forEach(number => {
                            number.classList.remove('content-number-bg');
                        });
                    };
                    
                    let activeIndex = 0;
                    if (progress < 0.25) {
                        activeIndex = 0;
                    } else if (progress < 0.75) {
                        activeIndex = 1;
                    } else {
                        activeIndex = 2;
                    }
                    
                    removeActiveClasses();
                    if (contentNumbers[activeIndex]) {
                        contentNumbers[activeIndex].classList.add('content-number-bg');
                    }
                }
            }
        }
    });
    
    const contentNumbers = document.querySelectorAll('.content-number');
    if(contentNumbers.length > 0){
        contentNumbers[0].classList.add('content-number-bg');
    }
    
    tl.to(".multi-image-parent-img.image-1", { opacity: 1, duration: 0.1 }, 0)
    .to(".multi-image-parent-img.image-1", { opacity: 0, duration: 0.5 }, 0.5)
    .to(".multi-image-parent-img.image-2", { opacity: 1, duration: 0.5 }, 0.5)
    .to(".multi-image-parent-img.image-2", { opacity: 0, duration: 0.5 }, 1.5)
    .to(".multi-image-parent-img.image-3", { opacity: 1, duration: 0.5 }, 1.5);
});